

export async function readFile(path) {
    return await (await fetch(path)).text();
}

export async function readJSONFile(path) {
    const rawText = await readFile(path);
    return JSON.parse(rawText);
}